// This file has been partially auto generated. 
// Please don't make any changes to the lenses.
// Feel free to add or remove annotated properties from
// the generator data class. The corresponding lenses 
// will be removed or added on the next run of the 
// lens generator. See below for more details.
package org.solyton.solawi.bid.module.bid.data.evaluation

import org.evoleq.optics.Lensify
import org.evoleq.optics.ReadOnly
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.bid.data.auction.AuctionDetails

/**
 * Generator class.
 * Feel free to add or remove annotated properties from
 * the class. Make sure that they are annotated with
 * - @ReadOnly
 * - @ReadWrite
 * If you want that a property-lens will be generated
 * on the next run of the lens generator.
 * If not, just omit the annotation or annotate it with @Ignore.
 */
@Lensify data class BidRoundEvaluation(
    @ReadOnly val auctionDetails: AuctionDetails = AuctionDetails(),
    @ReadOnly val totalSumOfWeightedBids: Double = 0.0,
    @ReadOnly val totalNumberOfShares: Int = 0,
    @ReadOnly val weightedBids: List<WeightedBid> = listOf()
)

/**
 * Autogenerated ReadOnly Lens.
 * Read [BidRoundEuation.auctionDetails]
 */
@ReadOnly val auctionDetails: Lens<BidRoundEvaluation, AuctionDetails> by lazy{ Lens(
    get = {whole -> whole.auctionDetails},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [BidRoundEvaluation.totalSumOfWeightedBids]
 */
@ReadOnly val totalSumOfWeightedBids: Lens<BidRoundEvaluation, Double> by lazy{ Lens(
    get = {whole -> whole.totalSumOfWeightedBids},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [BidRoundEvaluation.totalNumberOfShares]
 */
@ReadOnly val totalNumberOfShares: Lens<BidRoundEvaluation, Int> by lazy{ Lens(
    get = {whole -> whole.totalNumberOfShares},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [BidRoundEvaluation.weightedBids]
 */
@ReadOnly val weightedBids: Lens<BidRoundEvaluation, List<WeightedBid>> by lazy{ Lens(
    get = {whole -> whole.weightedBids},
    set = {{it}}
) }
